import { ProgressSpinner } from 'primereact/progressspinner';
import { RouteComponentProps } from 'react-router';
import classes from './landing-redirect.module.scss';
import { useAPIAuth } from '@developer/features';
import { AuthAgreementDialog } from '../../features';
import { ModalForDeactivatedUser } from '../landing-page/modal-for-deacrivated-user';

export const LandingRedirect = ({ location: { search } }: RouteComponentProps): JSX.Element => {
    const { hasDeveloperContext, userIsDeactivate } = useAPIAuth({
        search,
    });

    return (
        <div>
            {!userIsDeactivate && hasDeveloperContext === false && <AuthAgreementDialog />}
            {userIsDeactivate && hasDeveloperContext === false && <ModalForDeactivatedUser />}
            <div className={classes.overlay}>
                <ProgressSpinner />
            </div>
        </div>
    )
}